import React, { useEffect, useState } from 'react'
import './ReviewNotes.css';
import { Button } from '@mui/material';

const ReviewNotes = ({ applicationStatus, onSubmitNote }) => {
    const [note, setNote] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!note.trim()) return;

        try {
            // Call the API function passed as prop
            await onSubmitNote(note);

            // Clear the form after successful submission
            setNote('');
        } catch (error) {
            console.error('Error submitting note:', error);
        }
    };

    return (
        <div className="review-notes-container review-component-container full-width">
            <h2 className="review-notes-title">Review Notes</h2>
            <form onSubmit={handleSubmit}>
                <textarea
                    className="review-notes-textarea"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Enter your review notes here..."
                    disabled={applicationStatus !== "IN_REVIEW"}
                />
                <Button
                    variant='contained'
                    type="submit"
                    className="review-notes-submit"
                    sx={{
                        padding: '0.5rem 1.5rem',
                        backgroundColor: '#00707E',
                        textTransform: 'none',
                        '&:hover': {
                            backgroundColor: '#264E5A'
                        }
                    }}
                    disabled={applicationStatus !== "IN_REVIEW"}
                >
                    Submit note
                </Button>
            </form>
        </div>
    )
}

export default ReviewNotes